import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import ApiServices from "../../../service/ApiServices";
import { useEffect } from "react";
import { useUser } from "../../../app/context/user-context/user-context";
import { useCart } from "../../../app/context/cart-context/cart-context";

import {ReactComponent as SuccessIcon} from "../../../assets/images/icons/success.svg";


import './../notifications.css';

const res = new ApiServices();

export const Success = () => {

    const thisСustomer = useUser()
    const {clearCart} = useCart();

    const shipping = JSON.parse(localStorage.getItem('shipping'));
    
    delete shipping?.comment
    delete shipping?.shippingDate
    delete shipping?.shippingMethod
   
    useEffect(() => {
        res.addUser(shipping).then(data => {
            if (data.message !== 'Error') {
                thisСustomer.setСustomer({...shipping})
                localStorage.setItem('customer', JSON.stringify({...shipping}));
            }
        });
        clearCart();
    }, [])

    return (
        <motion.div className="container-fluid notifications"
            initial={{opacity: 0}}
            animate={{opacity: 1, trasition: { duration: 0.7}}}
            exit={{opacity: 0, trasition: { duration: 0.1}}}
        >
            <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="mt-5">
                    <SuccessIcon/>
                </div>
                <div className="mt-3 px-3 text-center">
                    <p className="h4">Ваше замовлення прийнято!</p>
                    <p className="h5">Очікуйте дзвінка адміністратора або кур'єра</p>
                </div>
                <div className="mt-5">
                    <Link
                        to={'/'}
                        className="btn"
                    >
                        На головну
                    </Link>
                </div>
            </div>
        </motion.div>
    )
}